export var PlatformType;
(function (PlatformType) {
    /**
     * 黃金甲
     */
    PlatformType[PlatformType["GOLDEN"] = 1] = "GOLDEN";
    /**
     * VR 彩票
     */
    PlatformType[PlatformType["VR"] = 2] = "VR";
    /**
     * OG 真人
     */
    PlatformType[PlatformType["OG"] = 3] = "OG";
    /**
     * AE 电子
     */
    PlatformType[PlatformType["AE"] = 4] = "AE";
    /**
     * BBIN 真人
     */
    PlatformType[PlatformType["BBIN"] = 5] = "BBIN";
    /**
     * DT 电子
     */
    PlatformType[PlatformType["DT"] = 6] = "DT";
    /**
     * JDB 电子
     */
    PlatformType[PlatformType["JDB"] = 7] = "JDB";
    /**
     * IM 体育
     */
    PlatformType[PlatformType["IM"] = 9] = "IM";
    /**
     * 开元棋牌
     */
    PlatformType[PlatformType["KY"] = 10] = "KY";
    /**
     * 泛亚电竞（开心电竞）
     */
    PlatformType[PlatformType["AVIA"] = 11] = "AVIA";
    /**
     * 沙巴体育
     */
    PlatformType[PlatformType["SABA"] = 12] = "SABA";
    /**
     * 欧博真人
     */
    PlatformType[PlatformType["AB"] = 13] = "AB";
    /**
     * PA 真人
     */
    PlatformType[PlatformType["PA"] = 14] = "PA";
    /**
     * CQ9 电子
     */
    PlatformType[PlatformType["CQ9"] = 15] = "CQ9";
    /**
     * eBET 真人
     */
    PlatformType[PlatformType["EBET"] = 16] = "EBET";
    /**
     * 皇冠體育（黃金甲體育）
     */
    PlatformType[PlatformType["CROWN"] = 17] = "CROWN";
    /**
     * 凱旋棋牌（GA 棋牌）
     */
    PlatformType[PlatformType["KX"] = 18] = "KX";
    /**
    * 小艾電競
    */
    PlatformType[PlatformType["ILUSTRE"] = 19] = "ILUSTRE";
    /**
     * 雷火電競 (GA 電競)
     */
    PlatformType[PlatformType["TF"] = 20] = "TF";
    /**
     * BTI 體育
     */
    PlatformType[PlatformType["BTI"] = 21] = "BTI";
    /**
     * 高登棋牌
     */
    PlatformType[PlatformType["GF"] = 22] = "GF";
    /**
     * 發財電子
     */
    PlatformType[PlatformType["FC"] = 23] = "FC";
    /**
     * AI 体育
     */
    PlatformType[PlatformType["AI"] = 24] = "AI";
    /**
     * 雙贏 彩票
     */
    PlatformType[PlatformType["SGWIN"] = 25] = "SGWIN";
    /**
     * KG 真人
     */
    PlatformType[PlatformType["KG"] = 26] = "KG";
    /**
     * 保利體育
     */
    PlatformType[PlatformType["POLY"] = 27] = "POLY";
    /**
     * KS 棋牌
     */
    PlatformType[PlatformType["KS"] = 28] = "KS";
    /**
     * BG 真人
    */
    PlatformType[PlatformType["BG"] = 29] = "BG";
    /**
     * PG 電子
     */
    PlatformType[PlatformType["PG"] = 30] = "PG";
    /**
     * PP 電子
     */
    PlatformType[PlatformType["PP"] = 31] = "PP";
    /**
     * FB 體育
     */
    PlatformType[PlatformType["FB"] = 32] = "FB";
    /**
     * 熊貓體育（PM 體育）
     */
    PlatformType[PlatformType["PM"] = 33] = "PM";
    /**
     * DB 真人
    */
    PlatformType[PlatformType["DB"] = 34] = "DB";
    /**
     * DB 電競
     */
    PlatformType[PlatformType["DB2"] = 35] = "DB2";
})(PlatformType || (PlatformType = {}));
//# sourceMappingURL=PlatformType.js.map